import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import AvailabilityCalendar from "@/components/AvailabilityCalendar";

export function AgendaDialog({ agendaFor, setAgendaFor, agendaData }) {
  return (
    <Dialog open={!!agendaFor} onOpenChange={(o) => !o && setAgendaFor(null)}>
      <DialogContent className="rounded-md max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-display">Agenda van {agendaFor?.name}</DialogTitle>
          <DialogDescription>Bekijk wanneer deze professional beschikbaar is.</DialogDescription>
        </DialogHeader>
        <div className="flex justify-center">
          <AvailabilityCalendar agenda={agendaData} editable={false} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
